import Vue from 'vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import VueRouter from 'vue-router';
import Dashboard from '../components/Dashboard.vue';
import DashboardShipments from '../components/DashboardShipments.vue';
import UserLayout from '../views/UserLayout.vue';
import Success from '../views/Success.vue';
import Cancel from '../views/Cancel.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    meta: {
      title: 'SoonForward',
    },
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/',
    component: UserLayout,
    meta: {
      title: 'SoonForward Web',
    },
    children: [
      {
        path: '/dash',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        children: [
          { path: '/', component: Dashboard },
          { path: '/dash/delivering', component: DashboardShipments },
          { path: '/dash/tooffload', component: DashboardShipments },
          { path: '/dash/toload', component: DashboardShipments },
          { path: '/dash/pickups', component: DashboardShipments },
          { path: '/dash/unpaid', component: DashboardShipments },
          { path: '/dash/delayed', component: DashboardShipments },
        ],
      },
      {
        path: '/manifest',
        name: 'Manifest',
        // route level code-splitting
        // this generates a separate chunk (manifest.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "manifest" */ '../views/Manifest.vue'),
      },
      {
        path: '/manifest-proto/:id?',
        name: 'ManifestProto',
        component: () => import('../views/Manifest2.vue'),
        meta: { permission: 'Manifest Details' },
      },
      {
        path: '/manifest-find',
        name: 'ManifestFind',
        component: () => import('../views/ManifestFind.vue'),
      },
      {
        path: '/shipment-find',
        name: 'ShipmentFind',
        component: () => import('../views/ShipmentFind.vue'),
      },
      {
        path: '/settings',
        name: 'UserProfile',
        component: () => import('../views/Settings.vue'),
        children: [
          { path: '/', component: () => import('../views/NotFoundComponent.vue') },
          {
            path: '/settings/account', component: () => import('../components/Profile.vue'),
          },
          {
            path: '/settings/roles', component: () => import('../views/RolesSettings.vue'), meta: { authorize: ['Admin', 'Owner'] },
          },
          {
            path: '/settings/office', component: () => import('../views/OfficeSettings.vue'), meta: { authorize: ['Admin', 'Owner'] },
          },
        ],
      },
      // {
      //   path: '/settings',
      //   name: 'UserProfile',
      //   component: () => import('../views/UserProfile.vue'),
      //   children: [
      //     {
      //       path: '/settings/account',
      //       component: () => import('../views/UserProfile.vue'),
      //     },
      //     // {
      //     //   path: '/settings/roles',
      //     //   component: () => import('../views/RolesSettings.vue'),
      //     // },
      //   ],
      // },
      // {
      //   path: '/settings/roles',
      //   component: () => import('../views/RolesSettings.vue'),
      // },
      {
        path: '/shipment/:id?',
        name: 'Shipment',
        component: () => import('../views/Shipment.vue'),
        meta: { permission: 'Booking Details' },
      },
      {
        path: '/search',
        name: 'Search',
        component: () => import('../views/Search.vue'),
      },
    ],
  },
  {
    path: '/verify-email',
    meta: {
      title: 'SoonForward',
    },
    name: 'EmailConfirmation',
    component: () => import('../views/VerifyEmail.vue'),
  },
  {
    path: '/shipmentStatus/',
    meta: {
      title: 'SoonForward',
    },
    name: 'ShipmentStatus',
    component: () => import('../views/CustomerShipmentStatus.vue'),
  },
  {
    path: '/updateShipmentStatus/:id?',
    meta: {
      title: 'SoonForward',
    },
    name: 'UpdateShipmentStatus',
    component: () => import('../views/UpdateShipmentStatus.vue'),
  },
  {
    path: '/onboarding/return',
    meta: { title: 'Stripe Onboarding Return' },
    component: () => import('../views/StripeOnboardingReturn.vue'),
  },
  {
    path: '/success',
    meta: { title: 'Payment Success' },
    component: Success,
  },
  {
    path: '/cancel',
    meta: { title: 'Payment Canceled' },
    component: Cancel,
  },
  {
    path: '*',
    name: 'Not Found',
    component: () => import(/* webpackChunkName: "not found" */ '../views/NotFoundComponent.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

function getCurrentUser() {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    },
    reject);
  });
}

router.beforeEach(async (to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
  const previousNearestWithMeta = from.matched.slice().reverse().find((r) => r.meta);
  const { authorize, permission } = to.meta;

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // let authRequired = false;
  const publicPages = ['/login', '/', '/verify-email', '/shipmentStatus', '/stripe-demo', '/success', '/cancel'];
  const authRequired = !publicPages.includes(to.path);
  // let authorized = false;

  // firebase.auth().onAuthStateChanged((user) => {
  //   if (user) {
  //     authorized = true;
  //     console.log('state = definitely signed in');
  //   } else {
  //     console.log('state = definitely signed out');
  //   }
  //   if (authRequired && !authorized) {
  //     document.title = 'SoonForward';
  //     next('/');
  //   }
  // });
  if (authRequired && !(await getCurrentUser())) {
    document.title = 'SoonForward';
    next('/');
  }

  // const authorized = localStorage.getItem('access') || localStorage.getItem('refresh');
  // if (authRequired && !authorized) {
  //   document.title = 'SoonForward';
  //   return next('/');
  // }

  if (authorize) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (authorize.length && !authorize.includes(user.roles)) {
      return next('/settings/account');
    }
  }

  if (permission) {
    const user = JSON.parse(localStorage.getItem('user'));
    const userPerm = user.permissions.find((perm) => perm.name === permission);
    if (permission.length && userPerm.value === 'no access') {
      return next('/dash');
    }
  }

  return next();
});

export default router;
